export default __webpack_public_path__ + "static/figma-34bba1a0a08365c02607773af91695cf.png";